import React from "react";
import BenifitsImage from "../../assets/images/career/young-environment.png";
import BenifitsSalaryImage from "../../assets/images/career/competitive-salary.png";
import CareerSupportiveImage from "../../assets/images/career/supportive-tech.png";
import CareerFunImage from "../../assets/images/career/fun-fridays.png";
import CareerPantryImage from "../../assets/images/career/feel-good-pantry.png";
import CareerMedicalImage from "../../assets/images/career/medical-insurance.png";

const Benifits = () => {
  const benefits = [
    {
      src: BenifitsImage,
      alt: "Young Environment",
      title: "Young Environment",
      desc: "Support our Clients' Business Processes",
    },
    {
      src: BenifitsSalaryImage,
      alt: "Competitive Salary",
      title: "Competitive Salary",
      desc: "Saving their Time and Cost, adding value to their bottom-line",
    },
    {
      src: CareerSupportiveImage,
      alt: "Supportive Tech",
      title: "Supportive Tech",
      desc: "Helping them in Identifying, Targeting & Leveraging New Opportunities",
    },
    {
      src: CareerFunImage,
      alt: "Fun Fridays",
      title: "Fun Fridays",
      desc: "Back their Presales, Business Development & Post Sales CRM",
    },
    {
      src: CareerPantryImage,
      alt: "Feel Good Pantry",
      title: "Feel Good Pantry",
      desc: "Power their Research and Knowledge Management Engine",
    },
    {
      src: CareerMedicalImage,
      alt: "Medical Insurance",
      title: "Medical Insurance",
      desc: "Our state-of-the-art server control, dedicated firewall setup enables you to run your business smoothly",
    }
  ];

  return (
    <section className="tw-py-20 lg:tw-py-28 tw-bg-slate-50/50 tw-border-t tw-border-solid tw-border-slate-100">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        
        {/* Header */}
        <div className="tw-text-center tw-mb-16">
          <span className="tw-inline-flex tw-items-center tw-gap-2 tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-uppercase tw-tracking-widest tw-mb-4 tw-bg-indigo-50 tw-px-4 tw-py-1.5 tw-rounded-full tw-border tw-border-solid tw-border-indigo-100">
            <span className="tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-[#5D44FF] tw-inline-block" />
            What we offer
          </span>
          <h2 className="tw-text-2xl sm:tw-text-3xl lg:tw-text-4xl tw-font-extrabold tw-text-slate-900 tw-leading-tight">
            Benefits
          </h2>
        </div>

        {/* Benefits Grid */}
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-8">
          {benefits.map((item, idx) => (
            <div
              key={idx}
              className="tw-relative tw-overflow-hidden tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-3xl tw-p-8 tw-shadow-sm hover:tw-shadow-xl hover:tw-scale-[1.03] tw-transition-all tw-duration-300 tw-text-left tw-flex tw-flex-col"
            >
              {/* Ghost watermark icon in background */}
              <div
                className="tw-absolute tw-bottom-[-12px] tw-right-[-12px] tw-w-28 tw-h-28 tw-opacity-[0.06] tw-pointer-events-none"
              >
                <img
                  src={item.src}
                  alt=""
                  aria-hidden="true"
                  className="tw-w-full tw-h-full tw-object-contain"
                />
              </div>

              {/* Icon box — unified indigo color matching the icon tones */}
              <div
                className="tw-w-14 tw-h-14 tw-mb-6 tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-rounded-2xl"
                style={{
                  backgroundColor: "#EEF2FF",
                  border: "1.5px solid #C7D2FE",
                }}
              >
                <img
                  src={item.src}
                  alt={item.alt}
                  className="tw-w-7 tw-h-7 tw-object-contain"
                />
              </div>

              {/* Text */}
              <h3 className="tw-text-lg tw-font-bold tw-text-slate-800 tw-mb-3">
                {item.title}
              </h3>
              <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0 tw-flex-grow">
                {item.desc}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Benifits;
